// Supabase requires passwords to be at least 6 characters long
export const minPasswordLength = 6
